import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class VrboChannelService {
  constructor(private http: HttpClient) {}

  /**
   * Update VRBO booking alteration status
   * @param externalInquiryId The external inquiry ID from VRBO
   * @param status The status to set ('accept' or 'decline')
   */
  updateAlteration(externalInquiryId: string, status: 'accept' | 'decline'): Observable<any> {
    const url = `@api/homeaway/alteration/booking`
    return this.http.put(url, { inquiry_id: externalInquiryId, status })
  }
}
